export default (id) => {
  const arr = [
    'Чоловічий халат',
    'Чоловічий костюм',
    'Жіночий халат',
    'Жіночий костюм',
    'Жилет',
    'Одяг для кухарів'
  ]
  return arr[Number(id) - 1]
}
